import { render, staticRenderFns } from "./SitesList.vue?vue&type=template&id=3bbabd32&scoped=true"
import script from "./SitesList.vue?vue&type=script&lang=js"
export * from "./SitesList.vue?vue&type=script&lang=js"
import style0 from "./SitesList.vue?vue&type=style&index=0&id=3bbabd32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbabd32",
  null
  
)

export default component.exports